// This is utils enum for use both modules and apps scope
export var AiChangeType;

(function (AiChangeType) {
  AiChangeType["Add"] = "add";
  AiChangeType["Update"] = "update";
  AiChangeType["Delete"] = "delete";
  AiChangeType["NoOperation"] = "no-operation";
})(AiChangeType || (AiChangeType = {}));